import Splide from "@splidejs/splide";
import { Intersection } from "@splidejs/splide-extension-intersection";


function initSplideNews(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-news").forEach((el) => {
		const splideNews = new Splide(el, {
			perPage: 3.5,
			gap: "25px",
			pagination: true,
			arrows: true,
			snap: true,
			focus: "left",
			interval: 3000,
			omitEnd: true,
			speed: 700,
			autoplay: "pause",
			pauseOnHover: true,
			intersection: {
				inView: {
					autoplay: true,
				},
				outView: {
					autoplay: false,
				},
			},
			breakpoints: {
				1100: { perPage: 3.2, gap: "25px" },
				991: { perPage: 2.5, gap: "25px" },
				640: { perPage: 1, gap: "12px" },
			},
		});

		splideNews.mount({ Intersection });

		
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSplideNews());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-news", ($block) => {
		initSplideNews($block && $block.jquery ? $block.get(0) : $block);
	});
}
